import { Provider as ProviderV3, View, defaultTheme } from '@adobe/react-spectrum';
import Provider from '@react/react-spectrum/Provider';
import { createBrowserHistory } from 'history';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import styled from 'styled-components';

// Shared libs
import { browseApi, commonApi } from '@exchange-frontends/api';
import { AppCrashComponent, ErrorBoundary, GlobalSkeletonStyles } from '@exchange-frontends/components';
import { makeVersionString } from '@exchange-frontends/utils';

import Browse from './Browse';
import Header from './Header';
import RedirectToBrowseEC from './RedirectToBrowseEC';

// Styled Components
/**
 * main content container
 * @memberof Browse
 * @type {styled-component}
 */
const BodyContainer = styled.div`
  padding-top: 40px;
  margin: 0 auto;
  max-width: 1440px;
  /* 1440 + 24 + 24 = 1488, therefore < 1489 needs padding */
  @media screen and (max-width: 1489px) {
    padding: 40px 24px;
  }
`;

export const ConfigContext = React.createContext(null);

window.xchgVersions = {
  ...(window.xchgVersions ?? {}),
  browse: makeVersionString(),
};

/**
 * App component including the router and react-spectrum providers
 * @component
 * @category Browse
 */
const App = ({ config }) => {
  browseApi.settings.setEndpoint(config?.apiUrl ?? process.env.ENDPOINT);
  browseApi.settings.setApiKey(config?.apiKey ?? process.env.API_KEY);
  commonApi.staticDataSettings.setEndpoint(config?.staticDataEndpoint ?? process.env.STATIC_DATA_ENDPOINT);
  commonApi.ccesSettings.setEndpoint(config?.ccesEndpoint ?? process.env.CCES_ENDPOINT);
  commonApi.ccesSettings.setApiKey(config?.ccesApiKey ?? process.env.CCES_API_KEY);
  commonApi.ccMostPopularTagsSettings.setEndpoint(
    config?.ccMostPopularTagsEndpoint ?? process.env.CC_MOST_POPULAR_TAGS_ENDPOINT
  );
  commonApi.getCreativeCloudLinkSettings.setEndpoint(config?.apiUrl ?? process.env.ENDPOINT);
  commonApi.getCreativeCloudLinkSettings.setApiKey(config?.apiKey ?? process.env.API_KEY);

  return (
    <ProviderV3 theme={defaultTheme} colorScheme={`light`}>
      <Provider toastPlacement="bottom center" theme="light">
        <GlobalSkeletonStyles />
        <ErrorBoundary errorComponent={<AppCrashComponent appName="Browse" />}>
          <Header />
          <View minHeight="100vh">
            <BodyContainer>
              <ConfigContext.Provider value={config}>
                <Routes>
                  <Route path="/" element={<RedirectToBrowseEC />} />
                  <Route path="ec" element={<Browse cloud="ec" />} />
                  <Route path="cc" element={<Browse cloud="cc" />} />
                  <Route path="*" element={<p>404</p>} />
                </Routes>
              </ConfigContext.Provider>
            </BodyContainer>
          </View>
        </ErrorBoundary>
      </Provider>
    </ProviderV3>
  );
};

export default App;
